module.exports = "/legacy/5b9397838e7ef2cb28d37a320e803c6f.svg";